/**
 * @version 1.0.1
 * @author wuwg  <wuwg@thunisoft.com>
 * @createTime:2019-08-13,
 * @updateTime:2019-08-13
 * @copyright thunisoft fd
 * @description  *  [jsDoc中文文档]{@link  http://www.dba.cn/book/jsdoc/JSDOCKuaiBiaoQianBLOCKTAGS/CONSTRUCTS.html}
 *  [jsdoc-vuejs]{@link  http://npm.taobao.org/package/jsdoc-vuejs}  -
 *  [个人博客]{@link  http://www.wuweigang.com}
 */
export default {
    name: 'xwzx',
    data() {
        return {
            crumbsList:Object.freeze([{
                name:'新闻资讯',
                key:'xwzx'
            }]),
            data: {
                tpxw: [],
                hsdt: [],
                szsx: [],
                hsxw: [],
                spxw: [],
                yw:[],
                tpyw: []
            }
        };
    },
    mounted() {
        this.initLatestXwzx();
    },
    methods: {
        // 查看更多
        handleMore(type) {
            this.$router.push({
                path: '/xwzx/more',
                query: {tab: type}
            });
        },
        // 查看详情
        handleDetail(item) {
            let _fileType = '23';
            if (item.gjlb === '2') {
                _fileType = '21';
            }
            if (item.gjlb === '3') {
                _fileType = '22';
            }
            const url = this.$router.resolve({path: '/xwzxDetail', query: {active:'xwzx', bh:item.bh, fileType: _fileType}});
            window.open(url.href, '_blank');
        },
        // 数据初始化
        initLatestXwzx() {
            const url = window.fdConfig.url.xwzx.latestXwzx;
            window.fdGlobal.ajax.get(url)
                .then((res) => {
                    if (res.data) {
                        this.data = res.data;
                    }
                });
        },
        // 获取多行省略
        getOverflowEllipsis(str, num = 145) {
            return str.length > num ? `${str.substring(0, num)}...` : str;
        }
    }
};

